import { get } from "@/services/axiosUitils";

export interface MorningBriefItem {
  icon: string;
  text: string;
  type: "success" | "warning" | "info" | "error";
}

export interface MorningBriefResponse {
  morning_brief: MorningBriefItem[];
}

const base = "/food_scanner/food-home-page/";

class FoodScannerService {
  getMorningBrief = async (
    date: string,
    groupId: string
  ): Promise<MorningBriefResponse> => {
    return await get<MorningBriefResponse>(base, {
      params: { date, group_id: groupId },
    });
  };
}

const instance = new FoodScannerService();
export default instance;
